import * as React from "react";
import { GRAPHQL_TYPE_PERSON, Person as GraphqlPerson } from "@radivision/graphql/lib/ts/graphql/person";
import { Router } from "../../utilities/router";
import { SVG } from "../../component-configuration/svgs";
import CS from "../../../static/ComingSoon.png";
import { getProfileInfo } from "../../utilities/get-profile-info";
import { AUTH_SIGNIN, AUTH_SIGNUP, AUTHENTICATION_MODAL_ID } from "../../redux/authentication/constants";
import { store } from "../../redux";
import { setAuthState } from "../../redux/actions";

interface Props {
  hideNavigation: boolean,
  user: GraphqlPerson,
  activePage: string,
  handleClick: any,
}

const NavBarRdv = ({ hideNavigation, user, activePage, handleClick } : Props) => {
  return (
    <ul className="navbar-nav ml-auto">
      {/* <li className="nav-item">
        <a
          className={`nav-link${activePage === "home" ? " active" : ""}`}
          onClick={(event: React.MouseEvent<HTMLElement>) =>
            handleClick(event, -1, "home", undefined, undefined)
          }
        >
          <span>Home</span>
        </a>
      </li> */}
      {!hideNavigation && (
        <>
          <li className="nav-item">
            <a
              className={`nav-link${activePage === "home" ? " active" : ""}`}
              href="/"
              onClick={(e) => {
                e.preventDefault();
                Router.navigateTo("/");
              }}
            >
              <span>Watch</span>
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link${activePage === "learn" ? " active" : ""}`}
              href="/learn"
              onClick={(event: React.MouseEvent<HTMLElement>) =>
                handleClick(event, -1, "learn", undefined)
              }
            >
              <span>Learn</span>
            </a>
          </li>
          <li className="nav-item dropdown moreDropdownMenu">
            <a
              className="nav-link dropdown-toggle more-dropdown"
              href="#"
              id="moreDropdownMenu"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="d-none d-lg-block">Connect</span>
              <span className="d-block d-lg-none">
                Connect<i>{SVG.caretRight}</i>
              </span>
            </a>

            <div className="dropdown-menu moreDropdownMenu" aria-labelledby="moreDropdownMenu">
              {!user && (
                <>
                  <a
                    className="dropdown-item d-sm-none"
                    href="/people"
                    onClick={(event: React.MouseEvent<HTMLElement>) => handleClick(event, -1, "people", undefined)}
                  >
                    People
                  </a>
                  <a
                    className="dropdown-item d-sm-none"
                    href="/buy"
                    onClick={(event: React.MouseEvent<HTMLElement>) => handleClick(event, -1, "buy", undefined)}
                  >
                    Marketplace
                  </a>
                </>
              )}
              {/* <a
                className="dropdown-item"
                href="/pitchplanet"
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                  handleClick(event, -1, "pitchplanet", undefined);
                }}
              >
                Pitch Planet
              </a> */}
              <a
                className="dropdown-item"
                href="/sheconomics"
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                  handleClick(event, -1, "sheconomics", undefined);
                }}
              >
                SHEconomics
              </a>
              <a
                className="dropdown-item"
                href="/black-is-the-new-green"
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                  handleClick(event, -1, "black-is-the-new-green", undefined);
                }}
              >
                Black is the New Green
              </a>
              <a
                className="dropdown-item"
                href="/ecosystem"
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                  handleClick(event, -1, "ecosystem", undefined);
                }}
              >
                Startup Ecosystem
              </a>

              <a
                className="dropdown-item soon"
                // href="/black-is-the-new-green"
                // onClick={(event: React.MouseEvent<HTMLElement>) => {
                //   handleClick(event, -1, "black-is-the-new-green", undefined);
                // }}
              >
                The Experts
                <img src={CS} width="80" height="45" />
              </a>
              <a
                className="dropdown-item soon"
                // href="/black-is-the-new-green"
                // onClick={(event: React.MouseEvent<HTMLElement>) => {
                //   handleClick(event, -1, "black-is-the-new-green", undefined);
                // }}
              >
                Equity IQ
                <img src={CS} width="80" height="45" />
              </a>

              {/* <a
                className="dropdown-item"
                href="/radical-visionaries"
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                  handleClick(event, -1, "radical-visionaries", undefined);
                }}
              >
                Radical Visionaries
              </a> */}

              {/* <a
                className="dropdown-item"
                href="/covidpreneurs"
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                  handleClick(event, -1, "covidpreneurs", undefined);
                }}
              >
                COVIDpreneurs
              </a> */}
            </div>
          </li>
          <li className="nav-item">
            <a
              href="/pitchplanet"
              className={`nav-link ${activePage === "pitchplanet" ? "active" : ""}`}
              onClick={(event: React.MouseEvent<HTMLElement>) =>
                handleClick(event, -1, "pitchplanet", undefined)
              }
            >
              <span>Invest</span>
            </a>
          </li>
          {/* <li className="nav-item">
            <a
              href="/buy"
              className={`nav-link ${activePage === "buy" ? "active" : ""}`}
              onClick={(event: React.MouseEvent<HTMLElement>) =>
                handleClick(event, -1, "buy", undefined)
              }
            >
              <span>Buy</span>
            </a>
          </li> */}
          {/* <li className="nav-item">
        <a
          href="/ecosystem"
          className={`nav-link${activePage === "ecosystem" ? " active" : ""}`}
          onClick={(event: React.MouseEvent<HTMLElement>) =>
            handleClick(event, -1, "ecosystem", undefined)
          }
        >
          <span>Ecosystem</span>
        </a>
      </li> */}

          {/* <li className="nav-item d-lg-none">
            <a
              className={`nav-link ${activePage === "about" ? "active" : ""}`}
              href="/about"
              onClick={(event: React.MouseEvent<HTMLElement>) => {
                handleClick(event, -1, "about", undefined);
              }}
            >
              <span>About</span>
            </a>
          </li> */}
          {user ? (
            <li className="nav-item dropdown d-block d-sm-none">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="userDropDownMenuMobile"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                My Profile<i>{SVG.caretRight}</i>
              </a>
              <div className="dropdown-menu" aria-labelledby="userDropDownMenuMobile">
                <a
                  className={`dropdown-item${
                    user !== null &&
                    user !== undefined &&
                    window.location.href === user.landingPageUrl
                      ? " active"
                      : ""
                  }`}
                  onClick={() => {
                    const { profileUrl } = getProfileInfo(user);
                    Router.navigateTo(profileUrl);
                  }}
                >
                  My Profile
                </a>
                {/* <a
              className="dropdown-item companyProfiles collapsable"
              href="#companyProfiles"
              data-expanded="false"
            >
              My Companies
            </a>
            <div
              className="collapse multi-collapse"
              id="companyProfiles"
            >
              <div className="card card-body">
                {user.entities === null ||
                user.entities === undefined
                  ? null
                  : user.entities.map((entity, index) => {
                      return (
                        <a
                          className="dropdown-item"
                          href={entity.landingPageUrl}
                          key={index}
                        >
                          {entity.name}
                        </a>
                      );
                    })}
              </div>
            </div> */}
                <a
                  className={`dropdown-item setting${activePage === "saved" ? " active" : ""}`}
                  href="/saved"
                  onClick={() => Router.to("saved")}
                >
                  My List
                </a>
                <a
                  className={`dropdown-item setting${
                    activePage === "following" ? " active" : ""
                  }`}
                  href="/following"
                  onClick={() => Router.to("following")}
                >
                  Following
                </a>
                <a
                  className={`dropdown-item setting${
                    activePage === "settings" ? " active" : ""
                  }`}
                  href="/account"
                  onClick={() => Router.to("account")}
                >
                  Settings
                </a>
                <a
                  className="dropdown-item signout"
                  onClick={() => {
                    import("../../authentication/cognito-client").then((module) => {
                      return module.CognitoClient.signOut(true);
                    });
                  }}
                >
                  Sign out
                </a>
                {/* <CreateCompanyButton /> */}
              </div>
            </li>
          ) : null}
          {/* <li className="nav-item dropdown moreDropdownMenu">
            <a
              className="nav-link dropdown-toggle more-dropdown"
              href="#"
              id="moreDropdownMenu"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="d-none d-lg-block ml-3 new-feature-label">Exclusive Events</span>
              <span className="d-block d-lg-none ml-3 new-feature-label">Exclusive Events<i>{SVG.caretRight}</i></span>
            </a>
            <div className="dropdown-menu moreDropdownMenu" aria-labelledby="moreDropdownMenu"><ExclusiveEventForm /></div>
          </li> */}
          <li className="nav-item dropdown moreDropdownMenu">
            <a
              className="nav-link dropdown-toggle more-dropdown"
              href="#"
              id="moreDropdownMenu"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="d-none d-lg-block">More</span>
              <span className="d-block d-lg-none">More<i>{SVG.caretRight}</i></span>
            </a>
            <div className="dropdown-menu moreDropdownMenu" aria-labelledby="moreDropdownMenu">
              <a
                className="dropdown-item"
                href="/get-started"
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                  handleClick(event, -1, "get-started", undefined);
                }}
              >
                Get Started
              </a>
              <a
                className="dropdown-item"
                href="/about"
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                  handleClick(event, -1, "about", undefined);
                }}
              >
                About
              </a>
              <a
                className="dropdown-item"
                href="/advocacy"
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                  handleClick(event, -1, "advocacy", undefined);
                }}
              >
                Advocacy
              </a>
              <a
                className="dropdown-item"
                href="/blog"
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                  handleClick(event, -1, "blog", undefined);
                }}
              >
                Media &amp; Blog
              </a>
              <a
                className="dropdown-item"
                href="/partners"
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                  handleClick(event, -1, "partners", undefined);
                }}
              >
                Partners
              </a>
            </div>
          </li>
        </>
      )}
      {/* user login or join on mobile */}
      {!user ? (
        <div className="xs-user-login d-block d-sm-none">
          <div className="join-btn">
            <a
              href="#"
              className="join"
              data-toggle="modal"
              data-target={`#${AUTHENTICATION_MODAL_ID}`}
              onClick={(e) => {
                e.preventDefault();
                store.dispatch(setAuthState({ step: AUTH_SIGNUP }));
                // toggleNavMenu();
              }}
            >
              Join
            </a>
          </div>
          <div className="login-btn">
            Already have an account?{" "}
            <a
              className="login"
              data-toggle="modal"
              data-target={`#${AUTHENTICATION_MODAL_ID}`}
              onClick={() => {
                // toggleNavMenu();
                store.dispatch(setAuthState({ step: AUTH_SIGNIN }));
              }}
              href="#"
            >
              Log in
            </a>
          </div>
        </div>
      ) : null}
    </ul>
  )
};

export default NavBarRdv;